import dayjs from 'dayjs'
import { createEvent } from 'ics'
import { saveAs } from 'file-saver'
import { AES, enc } from 'crypto-js'
import advancedFormat from 'dayjs/plugin/advancedFormat'
import { fetchBankHolidays } from '../utilities/fetchBankHolidays'
import { BookedSeat, BusinessUnit, ListOption } from '../types/andTypes'
dayjs.extend(advancedFormat)

export const getInitials = (input: string | null): string => {
  if (!input) return ''
  const match = input.match(/\b(\w)/g)

  if (match == null) return ''
  return match.join('').toUpperCase()
}

export const idToNameString = (input: string | null): string => {
  if (!input) return ''

  const lowCap = input.toLowerCase()
  const match = lowCap.replaceAll('.', ' ')

  if (match == null) return ''

  const nameSplit = match.split(' ')
  const capFirstLetter = nameSplit.map(names => names.charAt(0).toUpperCase() + names.slice(1))
  const nameOutput = capFirstLetter.toString().replace(/,/, ' ')
  return nameOutput
}

export const getUserId = (email: string): string => {
  return email.split('@')[0]
}

export const formatToReadableDate = (date: string | Date): string => {
  return dayjs(date).format('ddd Do MMM YYYY')
}

export const formatDate = (date: string | Date): string => {
  return dayjs(date).format('YYYY-MM-DD')
}

export const isBookedToday = (todaysSeats: BookedSeat[], userId: string) => {
  return (
    todaysSeats.filter(andi => {
      return andi.userId === userId
    }).length > 0
  )
}

export const generateNextWorkingDay = async (
  today: Date,
  region: string | undefined
): Promise<Date> => {
  const bankHolidays = await fetchBankHolidays(region)

  const matchedDate = await bankHolidays.find(
    holiday => dayjs(today).format('YYYY-MM-DD') === holiday
  )
  const isNonWorkingDay = matchedDate !== undefined || today.getDay() === 6 || today.getDay() === 0

  if (isNonWorkingDay) {
    return generateNextWorkingDay(dayjs(today).add(1, 'day').toDate(), region)
  }

  return today
}

export const generateIcsFile = (date: string, { name, location }: BusinessUnit): void => {
  const dates = date.split('-')

  createEvent(
    {
      start: [parseInt(dates[0]), parseInt(dates[1]), parseInt(dates[2]), 0, 0],
      duration: { hours: 24 },
      title: `${name} Desk Booking`,
      description: `You have booked a desk at ${name}`,
      location: `${name}, ${location}`,
      status: 'CONFIRMED',
      busyStatus: 'FREE'
    },
    (error, value) => {
      if (error) {
        // eslint-disable-next-line no-console
        console.error(error)
        return
      }

      const blob = new Blob([value], {
        type: 'text/calendar;charset=utf-8'
      })

      saveAs(blob, `${name} Desk Booking.ics`)
    }
  )
}

export const isDisabledDate = (date: Date, bankHolidays: string[]) =>
  date.getDay() === 0 || date.getDay() === 6 || bankHolidays.includes(formatDate(date))

export const createDisplayString = (
  item: ListOption | undefined,
  displayProperty: string,
  template?: string
): string => {
  if (!item) return ''

  if (template) {
    let buildString = template
    const displayProps = Object.keys(item)

    displayProps.forEach(property => {
      buildString = buildString.replace(`{${property}}`, `${item[property]}`)
    })
    return buildString
  } else return item[displayProperty] as string
}

/**
 * Count how many words in candidate string match the filterTerm, only using the beginning of each word
 * @param candidateToSearch string we want to search
 * @param filterTerm string to search for
 * @return true or false depending on whether it found the term
 */
export function isTermWithinAnyWord(candidateToSearch: string, filterTerm: string) {
  // split into words
  const words = candidateToSearch.toLowerCase().split(/[ ,]+/)

  const firstMatchingWord = words.find(word => word.indexOf(filterTerm.toLowerCase()) === 0)

  // indicate that we found something
  return firstMatchingWord !== undefined
}

export function swapElements<T>(arr: Array<T>, x: number, y: number): Array<T> {
  ;[arr[x], arr[y]] = [arr[y], arr[x]]
  return arr
}

export const encrypt = (text: string, secret: string): string => {
  try {
    return AES.encrypt(text, secret).toString()
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error('Unable to encrpyt Key. Please check the secret key and input text')
  }
  return ''
}

export const decrypt = (encryptedText: string, secret: string): string => {
  try {
    return AES.decrypt(encryptedText, secret).toString(enc.Utf8)
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error('Unable to decrypt Encrypted text. Please check the secret key and input text')
  }
  return ''
}
